import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { routes } from '@/core/router/routes';
import { Routes } from '@/core/router/routes.types';
import { getLaunchDarklyState } from '@/redux/launchDarkly';

export const useBrandTabRoutes = () => {
    const featureFlags = useSelector(getLaunchDarklyState);
    const showBannerTab = !featureFlags.isInitialized || !!featureFlags.banniereKiosk;

    return useMemo(() => {
        return routes
            .filter(({ tab }) => tab === 'brands')
            .filter(({ path }) => showBannerTab || path !== Routes.BrandPromotionalBanners);
    }, [showBannerTab]);
};
